module.exports = __webpack_public_path__ + "img/img_body_biz_fire_seoul_logo.e69e2377.png";